import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import EnhancedTable from '../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../widgets/Toolbar';
import LinkDialog from "../LinkDialog";
import Prompt from '../../widgets/Prompt';
import AlertItem from "../../widgets/AlertItem";
import SkillsProgramSetupSearch from '../program/SkillsProgramSetupSearch';
import ViewUtils from '../../ViewUtils';
import { OutComeStatusForm } from '../moderator/OutComeStatusForm';
import FormDialog from "../FormDialog";
import ModeratorInterventionAudit from '../moderator/ModeratorInterventionAudit';
import { ModeratorAssessmentEndDateForm } from "../common/ModeratorAssessmentEndDateForm";
import withMenuPermission from "../../widgets/withMenuPermission";


const headCells = [
    { id: 'SkillsProgrammeCode', numeric: false, disablePadding: true, label: 'Skills Programme ID' },
    { id: 'SkillsProgrammeTitle', numeric: false, disablePadding: true, label: 'Skills Programme Title' },
    { id: 'Credits', numeric: false, disablePadding: true, label: 'Credits' },
    { id: 'RegistrationStartDate', numeric: false, disablePadding: true, label: 'Registration Start Date' },
    { id: 'RegistrationEndDate', numeric: false, disablePadding: true, label: 'Registration End Date' },
    { id: 'AssessmentEndDate', numeric: false, disablePadding: true, label: 'Moderator Assessment End Date' },
    { id: 'Outcome', numeric: false, disablePadding: true, label: 'Outcome' },
    { id: 'Status', numeric: false, disablePadding: true, label: 'Status' }
];

const utils = new ViewUtils();
const toolbarRef = React.createRef();
const addFormRef = React.createRef();
const updateFormRef = React.createRef();

class ModeratorSkillsProgramme extends Component {

    constructor(props) {
        super(props)
        this.state = {
            model: {
                SAQASkillsProgrammeID: "",
                SAQASkillsProgrammeTitle: "",
                ModeratorID: this.props.location.state.ModeratorID
            },
            showTable: true,
            linkDialogOpen: false,
            auditDialogOpen: false,
            updateDialogOpen: false,
            updateDialogOpen: false,
            updateDateformDialogOpen: false,
            selectedSkillsProgramme: null,
            propmtOpen: false,
            promptTitle: "Unlink Skills Programme From Moderator",
            promptContent: "Are you sure you want to unlink this Skills Programme from the moderator?",
            message: "",
            messageStyle: "",
            searchParameters: [{ Name: "ModeratorID", Value: this.props.location.state.ModeratorID }]
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'link', label: '', tooltip: 'Link Skills Programme/s to the moderator', icon: 'LinkIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'update', label: '', tooltip: 'Update the status and outcome of the selected skills programme', disabled: utils.isNull(this.state.selectedSkillsProgramme), icon: 'UpdateIcon', visible: this.props.menuPermissionItem.Edit },
                        { id: 'audit', label: '', tooltip: 'View Record Audit Trail', disabled: utils.isNull(this.state.selectedSkillsProgramme) , icon: 'AuditIcon' },
                        { id: 'unlink', label: '', tooltip: 'Un-link selected skills programme from the moderator', disabled: utils.isNull(this.state.selectedSkillsProgramme), icon: 'LinkOffIcon', visible: this.props.menuPermissionItem.Delete },
                        { id: 'updateDate', label: 'Update Moderator Assessment End Date', tooltip: 'Update the Moderator Assessment End Date', disabled: utils.isNull(this.state.selectedSkillsProgramme), visible: this.props.menuPermissionItem.Edit }
                    ]
                }
            ]
        };
    }

    handleToolbarButtonClick = (buttonId) => {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/Moderator',
                state: { selection: this.props.location.state.ModeratorID }
            });
        }
        else if ("link" === buttonId) {
            this.setState({ linkDialogOpen: true, message: "" })
        }
        else if ("update" === buttonId) {
            this.setState({ updateDialogOpen: true, message: "" })
        }
        else if ("audit" === buttonId) {
            this.setState({ auditDialogOpen: true, message: "" })
        }
        else if ("unlink" === buttonId) {
            this.setState({ promptOpen: true })
        }
        else if ("updateDate" === buttonId) {
            this.setState({ updateDateDialogOpen: true, message: "" })
        }
    }

    successCallback = (response) => {
        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({
                selectedSkillsProgramme: null,
                message: response.Message,
                messageStyle: response.MessageType.toLowerCase()
            });
            //Force a refresh
            this.setState({
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
            })
        }
        else if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({
                message: response.Message,
                messageStyle: response.MessageType.toLowerCase()
            })
        }
    }

    successUnlinkCallback = (response) => {

        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({ selectedSkillsProgramme: null, removeMessage: response.Message, removeMessageStyle: response.MessageType.toLowerCase() });
            this.setState({ searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)) })
        }
    }

    unlinkSkillsProgramme(url) {
        this.setState({ promptOpen: false }, () => {
            toolbarRef.current.setButtonDisabled("unlink", true);
        })

        let fullUrl = `${url}?id=${this.state.selectedSkillsProgramme}&moderatorId=${this.props.location.state.ModeratorID}`;
        utils.invokeUrlDelete(fullUrl, this.successUnlinkCallback, this.unsuccessfulUnlinkCallback);
    }

    postLinkHandler(isCancel, linked) {
        if (linked === true) {
            this.setState({
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                linkDialogOpen: false, auditDialogOpen: false, selectedSkillsProgramme: null
            });
        }
        else if (isCancel === true) {
            this.setState({
                linkDialogOpen: false,
                auditDialogOpen: false
            })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({
                selectedSkillsProgramme: selection[0].Id,
                message: "",
                messageStyle: ""
            });
        } else {
            this.setState({
                selectedSkillsProgramme: null,
                message: "",
                messageStyle: ""
            });
        }
        toolbarRef.current.setButtonDisabled("unlink", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("update", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("updateDate", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("audit", selection === null || selection.length === 0);
    }

    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    unsuccessfulUnlinkCallback = (response) => {
        if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({ removeMessage: response.Message, removeMessageStyle: response.MessageType.toLowerCase() })
        }
    }

    dialogActionHandler(isCancel, added) {
        if (added === true) {
            this.setState({
                showTable: false,
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                updateDialogOpen: false, updateDateDialogOpen: false, selectedSiteVisit: null, linkDialogOpen: false, auditDialogOpen: false, selection: this.props.location.state.selection, selectedSkillsProgramme: null
            }, () => {
                this.setState({ showTable: true })
            });
        }
        else if (isCancel === true) {
            this.setState({
                updateDialogOpen: false,
                updateDateDialogOpen: false,
                linkDialogOpen: false,
                auditDialogOpen: false
            })
        }
    }

    dialogUpdateActionHandler(isCancel, added) {
        if (added === true) {
            this.setState({
                showTable: false,
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                updateDialogOpen: false, updateDateDialogOpen: false, selectedSiteVisit: null, linkDialogOpen: false, auditDialogOpen: false, selection: this.props.location.state.selection, selectedSkillsProgramme: null
            }, () => {
                this.setState({ showTable: true })
            });
        }
        else if (isCancel === true) {
            this.setState({
                updateDialogOpen: false,
                updateDateDialogOpen: false,
                linkDialogOpen: false,
                auditDialogOpen: false
            })
        }
    }

    render() {
        return (

            <ViewContainer title="">

                <p className="breadcrumbs">
                    {"Moderator > Skills Programmes " + (this.props.location.state.ModeratorName !== null ? "> " + this.props.location.state.ModeratorName : "> Add")}
                </p>

                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />

                <div className="searchResults">
                    <EnhancedToolbar
                        ref={toolbarRef}
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        config={this.toolbarConfig} />

                    {this.state.showTable === true && (

                        <EnhancedTable
                            height="50vh"
                            headCells={headCells}
                            dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/ModeratorSkillsProgramme/GetModeratorSkillsProgrammes"}
                            onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                            searchParameters={this.state.searchParameters} paged={true} />
                    )}
                </div>

                <LinkDialog open={this.state.linkDialogOpen} type={this.state.selectedLinkType}
                    title={this.props.location.state.SkillsProgrammeTitle}
                    closeHandler={(isCancelled, linked) => this.postLinkHandler(isCancelled, linked)}
                    dialogTitle={`Link Skills Programmes to Moderator > ${this.props.location.state.ModeratorName}`}
                    linkName={"SkillsProgrammes"} postUrl={"api/sims/ModeratorSkillsProgramme/linkModeratorSkillsProgrammes"}
                    selectionId={this.props.location.state.ModeratorID} usePost={true}
                >

                    <SkillsProgramSetupSearch dataUrl="api/sims/ModeratorSkillsProgramme/GetModeratorLinkableSkillsProgrammes"
                        multiSelect={true} showTitle={false}
                        programmeId={this.props.location.state.ModeratorID}
                        mode="lookup"
                    />
                </LinkDialog>

                <FormDialog
                    open={this.state.updateDialogOpen}
                    dialogTitle={"Update Outcome and Status"}
                    viewRef={this}
                    entityId={this.state.selectedSkillsProgramme}
                    formRef={addFormRef}
                    usePut={true}
                    saveUrl={"api/sims/ModeratorSkillsProgramme/updateModeratorSkillsProgramme"}
                    closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                >
                    <OutComeStatusForm
                        ref={addFormRef}
                        id={this.state.selectedSkillsProgramme}
                        controllerName={"ModeratorSkillsProgramme"}
                        dataURL='api/sims/ModeratorSkillsProgramme/GetFindSkillsProgrammeOutcome'
                    />
                </FormDialog>

                <FormDialog
                    open={this.state.updateDateDialogOpen}
                    dialogTitle={"Update Assessor Assessment End Date"}
                    viewRef={this}
                    entityId={this.state.selectedUnitStandard}
                    formRef={updateFormRef}
                    usePut={true}
                    saveUrl={"api/sims/ModeratorSkillsProgramme/UpdateSkillsProgrammeAssessmentEndDate"}
                    closeHandler={(isCancelled, linked) => this.dialogUpdateActionHandler(isCancelled, linked)}
                >
                    <ModeratorAssessmentEndDateForm ref={updateFormRef} id={this.state.selectedSkillsProgramme} dataURL='api/sims/ModeratorSkillsProgramme/GetFindSkillsProgrammeAssessmentEndDate' controllerName='moderatorskillsprogramme' />
                </FormDialog>

                <LinkDialog open={this.state.auditDialogOpen}
                    title={"Audit Trail"}
                    closeHandler={(isCancelled, linked) => this.postLinkHandler(isCancelled, linked)}
                    dialogTitle={"Audit Trail"}
                    selectionId={this.props.location.state.selectedSkillsProgramme}
                >

                    <ModeratorInterventionAudit dataUrl={"api/sims/ModeratorSkillsProgramme/getModeratorSkillsProgrammeAudit"}
                        multiSelect={false} showTitle={false}
                        Id={this.state.selectedSkillsProgramme}
                    />
                </LinkDialog>

                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => this.unlinkSkillsProgramme("api/sims/ModeratorSkillsProgramme/RemoveModeratorSkillsProgramme")}
                    closePrompt={this.closePrompt}
                />
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(ModeratorSkillsProgramme));